import { GENERATED_TASK_CHECKLIST_ITEM_ID_PREFIX } from '../store/taskChecklistItems'

export const isChecklistItemIdNew = (checklistItemId) => {
  return checklistItemId.indexOf(GENERATED_TASK_CHECKLIST_ITEM_ID_PREFIX) !== -1
}



// WEBPACK FOOTER //
// ./src/util/checklistHelper.js